import { ReactNode } from "react";
import { Header } from "@/components/layout/Header";
import { UnifiedFooter } from "@/components/layout/UnifiedFooter";
import { PrivacyPolicyConsent } from "@/components/consent/PrivacyPolicyConsent";

interface RootLayoutProps {
  children: ReactNode;
  hideHeader?: boolean;
  hideFooter?: boolean;
}

/**
 * Root Layout.
 */
export function RootLayout({
  children,
  hideHeader = false,
  hideFooter = false,
}: Readonly<RootLayoutProps>) {
  return (
    <div className="flex flex-col min-h-screen w-full max-w-none bg-white">
      {!hideHeader && <Header />}
      <main className="flex-1 w-full max-w-none">{children}</main>
      {!hideFooter && <UnifiedFooter />}
      <PrivacyPolicyConsent />
    </div>
  );
}
